document.addEventListener("DOMContentLoaded",function() {
	const rejectButton = document.querySelector(".button--reject");
	const acceptButton = document.querySelector(".button--accept");

	rejectButton && rejectButton.addEventListener("click", function () {
		// Cookies rejected - hide banner and specify rejection
		document.getElementsByClassName("cookie-consent-banner")[0].classList.add("cookie-consent-banner--close");
		localStorage.removeItem('consent');
		localStorage.setItem('consent', 'false');
	})

	acceptButton && acceptButton.addEventListener("click", function () {
		// Cookies accepted - hide banner and specify acception
		document.getElementsByClassName("cookie-consent-banner")[0].classList.add("cookie-consent-banner--close");
		localStorage.setItem('consent', 'true');
	})

	// if(localStorage.hasOwnProperty('consent')) {
	// 	// Storage already set, hide banner
	// 	document.getElementsByClassName("cookie-consent-banner")[0].classList.add("cookie-consent-banner--close");
	// }
});